export default {
      id: "icon-instagram-usage",
      viewBox: "0 0 22.996 23",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-instagram",
      toString: function () {
        return this.url;
      }
    }